import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["blueprint", "note", "kind", "submit"]

  connect() {
    this.toggleInputs()
  }

  toggleInputs() {
    const selected = this.blueprintTarget.value && this.blueprintTarget.value.trim() !== ""

    this.noteTarget.disabled = !selected
    this.submitTarget.disabled = !selected

    this.kindTargets.forEach((input) => {
      input.disabled = !selected
    })
  }
}
